import React from 'react'
import { user } from '../../core/controllers/user'
import { billing } from '../../core/controllers/Billing'
import { modal } from '../../core/utilities/modal'
import { browserHistory } from 'react-router'

import {subscription} from '../../core/controllers/Subscription';
import DotProgress from '../../core/utilities/DotProgress'

export default class SubscriptionTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            overviewActive: 'active',
            invoicesActive: '',
            originalSelectedPlan: 1,
            selectedPlan: 1,
            invoices: null,
            subscription: null,
            usingCC: false,
        };

        this.options = {
            defaultSortName: 'date',
            defaultSortOrder: 'desc'
        };
    }

    componentDidMount() {
        var self = this;
        subscription.getSubscription(function(response) {
            if (response.data != null) {
                var invoices = Array();
                if (response.data.invoices != null) {
                    response.data.invoices
                    response.data.invoices.forEach(invoice => {
                        invoices.push({
                            amount: invoice.subscription.price / 100,
                            description: 'Plan charge - Service fee',
                            status: invoice.status,
                            date: invoice.invoice.created_at
                        });
                    });
                }
                self.setState({
                    subscription: response.data,
                    originalSelectedPlan: response.data.subscription.subscription_id,
                    selectedPlan: response.data.subscription.subscription_id,
                    invoices: invoices.length > 0 ? invoices : null
                });
            }
        });
    }

    handleTabChange(type) {
        if (type == 'overview') {
            this.setState({
                overviewActive: 'active',
                invoicesActive: '',
            });
        } else if (type == 'invoices') {
            this.setState({
                overviewActive: '',
                invoicesActive: 'active',
            });
        }
    }

    validateUpdateSubscription(callback) {
        const selectedPlan  = this.state.selectedPlan
        if (selectedPlan == 2 || selectedPlan == 3) {
            if (user.userInfo.billing_setup) {
                billing.getProfile(billing => {
                    // let cards = billing.data.cards
                    // let hasCard = cards.length > 0;
                    // var testIntCard = false;
                    // if (hasCard) {
                    //     cards.forEach(card => {
                    //         if (card.default) {
                    //             testIntCard = card.card_international;
                    //         }
                    //     });
                    // }
                    // this.setState({
                    //     usingCC: hasCard,
                    //     usingIntl: testIntCard
                    // }, () => {
                        if (billing) {
                            if (billing.data.banks.length == 0) {
                                modal.showDangerModalWithOK("Bank Account Not Linked!","You have not linked a bank account!","Link Now");
                                jQuery(".move-on").on('click',function() {
                                    browserHistory.push('/account/billing');
                                })
                                callback(false);
                            } else {
                                callback(true);
                            }
                        }
                    // })
                });
            } else {
                modal.showDangerModalWithOK("Billing Profile Not Set Up!","You have not set up a billing profile!","Set Up Now");
		        jQuery(".move-on").on('click',function() {
                    browserHistory.push('/account/billing');
                })
                callback(false);
            }
        } else if (selectedPlan == 1) {
            callback(true);
        }
    }

    handleUpdateSubscription() {
        var self = this;
        this.validateUpdateSubscription(function(valid) {
            if (!valid) {
                return;
            }

            let showModal = () => {
                modal.showSuccessModalWithOK("Change Plan?", "You are about to change your subscription, continue?", "Continue");
                jQuery(".move-on").on('click', function () {
                    subscription.updateSubscription(self.state.selectedPlan, function (response) {
                        modal.showInfo("Subscription plan successfully changed!", "success", "top", "center");
                        self.setState({
                            originalSelectedPlan: self.state.selectedPlan,
                            selectedPlan: self.state.selectedPlan,
                            invoices: response.data.invoices != null ? response.data.invoices.invoices : null
                        });
                        user.forceUpdate();
                    });
                })
            }
            let intl = self.state.usingIntl
            if(self.state.usingCC){ modal.showDangerModalWithOK(
                    "Confirm Payment",
                    `A transaction fee of ${intl ? '5' : '3'}% + 0.30 will be charged for each 
                    payment due to the ${intl ? 'international ' : '' }credit card linked`,
                    "Continue"
                )
                jQuery(".move-on").on('click', () => {showModal()})
            } else { showModal(); }
        })
    }

    handlePlanChanged(plan) {
        if (plan == "basic") {
            this.setState({
                selectedPlan: 1,
            })
        } else if (plan == "premium") {
            this.setState({
                selectedPlan: 2,
            })
        } else if (plan == "enterprise") {
            this.setState({
                selectedPlan: 3,
            })
        }
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatMoney(cell, row) {
        var money = cell;
        var cssClass = "positive";
        if (money < 0) {
            cssClass = "negative";
        }

        let fee = row.is_credit_card ?
            row.is_international_card ?
                ' + 5% + 0.30 (international credit card)'
                : ' + 3% + 0.30 (credit card)'
            : ''

        money = Number(money.toFixed(2)).toLocaleString()
        money.toLocaleString("en-US", {style:"currency", currency:"USD"});

        return "<span class='table-"+cssClass+"'>$"+money+fee+"</span>";
    }

    formatDate(cell, row) {
        return moment(cell).format('MMMM Do YYYY');
    }

    formatStatus(cell, row) {
        var status = <DotProgress dotPos={2} date={row.due_at}/>
        if (cell == 'PAID') {
            status = <DotProgress dotPos={3} date={row.due_at}/>
        } else if (cell == 'VOID') {
            status = '<span class="important-small-gray">Cancelled</span>';
        } else if (cell == 'EXPIRED') {
            status = '<span class="important-small-red">Expired</span>';
        } else if (cell == 'FAILED') {
            status = '<span class="important-small-red">Failed</span>';
        } else if (cell == 'REFUNDED') {
            status = '<span class="important-small-blue">Refund</span>';
        } else if (cell == 'NONE') {
            status = <DotProgress dotPos={1} date={row.due_at}/>
        }

        return status;
    }

    render() {
        const overviewActive        = this.state.overviewActive;
        const invoicesActive        = this.state.invoicesActive;
        const basicPlanText         = "Rent Collection\nLink Multiple Bank Accounts\nManage Properties\nManage Tenants\nManage Leases\nManage Maintenance\nRenters Insurance Purchase\nBackground Checks\nManage Leads\nManage Finances\nManage Fees";
        const premiumPlanText       = "All of Basic\nUnlimited Properties\nManage Listings\nOwners\nOwner Payouts\nFull Reports\nQuickbooks Desktop Integrations";
        const enterprisePlanText    = "All of Premium\nCustom Feature Development\nDedicated Customer Support\nBuilding Integration Support/Help\nCamera Integrations\nSensor Integrations\nHVAC Integrations\nAccess Control Integrations\nFacility Management Integrations";
        const invoices              = this.state.invoices;

        const selectedPlan          = this.state.selectedPlan;
        var basicSelect, basicButtonText, premiumSelect, premiumButtonText, enterpriseSelect, enterpriseButtonText = "";
        var disableBasic, disablePremium, disableEnterprise = true;
        if (selectedPlan == 1) {
            basicSelect = "selected"
            premiumSelect = ""
            enterpriseSelect = ""
            basicButtonText = "Selected"
            premiumButtonText = "Select Plan"
            enterpriseButtonText = "Select Plan"
            disableBasic = true
            disablePremium = false
            disableEnterprise = false
        } else if (selectedPlan == 2) {
            basicSelect = ""
            premiumSelect = "selected"
            enterpriseSelect = ""
            basicButtonText = "Select Plan"
            premiumButtonText = "Selected"
            enterpriseButtonText = "Select Plan"
            disableBasic = false
            disablePremium = true
            disableEnterprise = false
        } else if (selectedPlan == 3) {
            basicSelect = ""
            premiumSelect = ""
            enterpriseSelect = "selected"
            basicButtonText = "Select Plan"
            premiumButtonText = "Select Plan"
            enterpriseButtonText = "Selected"
            disableBasic = false
            disablePremium = false
            disableEnterprise = true
        }

        const originalSelectedPlan = this.state.originalSelectedPlan;
        var updatePlanButton = ""
        var disableUpdatePlan = false
        if (originalSelectedPlan > selectedPlan) {
            updatePlanButton = "Downgrade Plan"
        } else if (originalSelectedPlan == selectedPlan) {
            disableUpdatePlan = true
            updatePlanButton = "Upgrade Plan"
        } else {
            updatePlanButton = "Upgrade Plan"
        }
        var originalPlanBasic, originalPlanPremium, originalPlanEnterprise = "";
        if (originalSelectedPlan == 1) {
            originalPlanBasic = "original-plan"
            originalPlanPremium = ""
            originalPlanEnterprise = ""
        } else if (originalSelectedPlan == 2) {
            originalPlanBasic = ""
            originalPlanPremium = "original-plan"
            originalPlanEnterprise = ""
        } else if (originalSelectedPlan == 3) {
            originalPlanBasic = ""
            originalPlanPremium = ""
            originalPlanEnterprise = "original-plan"
        }

        return (
        <div class="row blue-bottom-margin">
            <div class="row">
                <div class="main-page-header-row col-md-12">
                    <div class="col-md-12">
                        <span class="main-page-header-title">Subscription Management</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <h4 class={"cross-tab-select " + overviewActive} onClick={this.handleTabChange.bind(this, 'overview')}>OVERVIEW</h4>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <h4 class={"cross-tab-select " + invoicesActive} onClick={this.handleTabChange.bind(this, 'invoices')}>INVOICES</h4>
                    </div>
                </div>
            </div>
            {overviewActive == 'active' && (
            <div>
                <div class="row">
                    <div class="col-md-12 subscription-select-row">
                        <div class="col-md-4 col-sm-4 col-xs-12">
                            <div class={"card " + originalPlanBasic + " subscription-card " + basicSelect}>
                                <div class="subscription-title">Basic</div>
                                <div class="subscription-price">$0</div>
                                <div class="subscription-per-month-message">Always free</div>
                                <hr />
                                <div>{basicPlanText}</div>
                                <button type="button" disabled={disableBasic} data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill subscription-select-btn" autoComplete="off" onClick={this.handlePlanChanged.bind(this, "basic")}>{basicButtonText}</button>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-xs-12">
                            <div class={"card " + originalPlanPremium + " subscription-card " + premiumSelect}>
                                <div class="subscription-title">Premium</div>
                                <div class="subscription-price">$40</div>
                                <div class="subscription-per-month-message">Per month</div>
                                <hr />
                                <div>{premiumPlanText}</div>
                                <button type="button" disabled={disablePremium} data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill subscription-select-btn" autoComplete="off" onClick={this.handlePlanChanged.bind(this, "premium")}>{premiumButtonText}</button>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-xs-12">
                            <div class={"card " + originalPlanEnterprise + " subscription-card " + enterpriseSelect}>
                                <div class="subscription-title">Enterprise</div>
                                <div class="subscription-price">$400</div>
                                <div class="subscription-per-month-message">Per month</div>
                                <hr />
                                <div>{enterprisePlanText}</div>
                                <button type="button" disabled={disableEnterprise} data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill subscription-select-btn" autoComplete="off" onClick={this.handlePlanChanged.bind(this, "enterprise")}>{enterpriseButtonText}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="center-text col-md-7 col-md-offset-2">
                        <p>
                            Subscriptions will prioritize credit cards as the payment method if an 
                            accont is linked. Credit Card payments will process with a 3% + $0.30 fee or 
                            5% + $0.30 for non-US cards.
                        </p>
                    </div>
                </div>
                <div class="row blue-bottom">
                    <div class="blue-bottom-center-align">
                        <div class="col-md-12">
                            <button type="button" disabled={disableUpdatePlan} data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.handleUpdateSubscription.bind(this)}>
                            {updatePlanButton}
                            </button>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
            )}
            {invoicesActive == 'active' && (
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Invoice History</h4>
                            {invoices != null ? (
                                <p class="category">Showing a total of {invoices.length} invoice{invoices.length > 1 && "s"}</p>
                            ) : (
                                <p class="category">Complete list of all invoices</p>
                            )}
                        </div>
                        <div class="content">
                            <div>
                            {invoices != null ? (
                                <BootstrapTable data={invoices} options={ this.options } version='4' striped search pagination>
                                    <TableHeaderColumn width="100" dataField='id' dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                    <TableHeaderColumn dataField='description'>Description</TableHeaderColumn>
                                    <TableHeaderColumn dataField='status' width="150" dataFormat={this.formatStatus.bind(this)}>Status</TableHeaderColumn>
                                    <TableHeaderColumn dataField='amount' width="150" dataFormat={this.formatMoney.bind(this)} dataSort={true}>Amount($)</TableHeaderColumn>
                                    <TableHeaderColumn dataField='date' width="150" dataFormat={this.formatDate} dataSort={true}>Submitted</TableHeaderColumn>
                                </BootstrapTable>
                            ) : (
                                <p>No invoices found.</p>
                            )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}
        </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Subscription/Subscription.jsx